import { useNavigate } from 'react-router-dom'
import { BackButton, Breadcrums } from '../../Components/Shared'
import ComingSoon from '../ComingSoon'

const Helpdesk = () => {
  const navigate = useNavigate()
  const breadcrumbs = [
    { label: 'Home', path: '/', active: false, image: null },
    { label: 'Helpdesk', path: '', active: true, image: null },
  ]

  return (
    <div className='help-desk w-100'>
      <div className={'role__editor p-16'}>
        <div className='p-8'>
          <Breadcrums breadcrums={breadcrumbs} />
        </div>
        <div className='p-8'>
          <BackButton
            label={'Helpdesk'}
            className='col73'
            handleOnClick={() => {
              navigate('/home')
            }}
          />
        </div>
        <ComingSoon />
      </div>
    </div>
  )
}

export default Helpdesk
